/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 礼品卡明细
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GiftCardConsumptionParams {
  constructor(
    public id: string,
    public pageNum: number,
    public pageSize: number
  ) {}
}

export default async function (
  params: GiftCardConsumptionParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.Page<member.GiftCardConsumptionDTO>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/consumption`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
